import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-yandex', 'BrandYandex', [["path",{"d":"M15 20v-16h-2a4 4 0 0 0 -4 4v1a4 4 0 0 0 4 4h2"}],["path",{"d":"M9 20l3 -7"}]]);